<template>
  <v-row justify="center">
    <v-dialog
      v-model="settings_dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar
          dark
          color="primary">
          <v-btn
            icon
            dark
            @click="show_dialog(false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Settings</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              dark
              text
              @click="save">
              Save
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-list
          two-line
          subheader>
          <v-subheader>General</v-subheader>
          <v-row>
            <v-col cols="5">
              <!-- ZOOM SLIDER -->
              <v-list-item>
                <v-list-item-content>
                  <div class="d-flex justify-space-between align-center">
                    <v-list-item-title>Screen Zoom</v-list-item-title>
                    <span class="primary--text font-weight-bold">{{ (ui_scale * 100).toFixed(0) }}%</span>
                  </div>
                  <v-slider
                    v-model="ui_scale"
                    min="0.25"
                    max="1.75"
                    step="0.05"
                    hide-details
                    thumb-label
                    class="mt-2"
                  ></v-slider>
                  <v-list-item-subtitle>Adjust size of orders (Reflows Columns)</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <!-- END ZOOM SLIDER -->
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="pre_orders" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Show Pre-Orders</v-list-item-title>
                  <v-list-item-subtitle>Show pre-orders that are not paid yet</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="paid_orders" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Show Orders</v-list-item-title>
                  <v-list-item-subtitle>Show orders that are paid</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="dark_mode" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Dark Mode</v-list-item-title>
                  <v-list-item-subtitle>Switch to Dark Mode</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="enable_preparing" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Enable Preparing</v-list-item-title>
                  <v-list-item-subtitle>Enable Preparing Status</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="syncing" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Enable Syncing</v-list-item-title>
                  <v-list-item-subtitle>Enable Syncing To Local Server</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="enable_sync_completion_status" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Enable Syncing Orders Completion Status</v-list-item-title>
                  <v-list-item-subtitle>Sync completed orders status (DONE) to local server</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="is_grouped" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Is Grouped</v-list-item-title>
                  <v-list-item-subtitle>Group Similar Items Together</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="send_sms" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Send SMS</v-list-item-title>
                  <v-list-item-subtitle>Enable SMS notifications</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="show_the_side_bar_priority_items" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Show Side Bar Priority Items</v-list-item-title>
                  <v-list-item-subtitle>Show Priority Items</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-action>
                  <v-switch v-model="enable_multi_kds_setup" inset></v-switch>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>Enable Multi KDS Setup</v-list-item-title>
                  <v-list-item-subtitle>Order Distribution Across Multiple KDS</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-col>
            <v-col cols="5">
              <v-list-item>
                <v-select
                  dense
                  append-icon=""
                  clearable
                  label="Transformer"
                  hint="Select the corresponding transformer for your ERP endpoint"
                  persistent-hint
                  v-model="selected_transformer"
                  :items="transformers">
                </v-select>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Local Server Host"
                  clearable
                  hint="Local Server Host. EX: http://192.168.1.1:9200"
                  persistent-hint
                  v-model="local_server_host">
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Server Endpoint"
                  clearable
                  hint="Server endpoint to get orders from, leave empty for local"
                  persistent-hint
                  v-model="server_endpoint">
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Authorization Token"
                  clearable
                  hint="Token for secure access"
                  persistent-hint
                  v-model="token">
                </v-text-field>
              </v-list-item>
              <v-list-item v-if="send_sms">
                <v-text-field
                  dense
                  label="SMS Message"
                  clearable
                  hint="SMS message template to send"
                  persistent-hint
                  required
                  :rules="smsRules"
                  v-model="sms_message">
                </v-text-field>
              </v-list-item>
              <v-list-item v-if="send_sms">
                <v-text-field
                  dense
                  label="SMS Sender Name"
                  clearable
                  hint="Name to appear as SMS sender"
                  persistent-hint
                  required
                  :rules="smsRules"
                  v-model="sms_sender_name">
                </v-text-field>
              </v-list-item>
              <v-list-item v-if="send_sms">
                <v-autocomplete
                  dense
                  label="SMS Account"
                  clearable
                  hint="SMS Account Settings & Credentials"
                  persistent-hint
                  required
                  :rules="smsRules"
                  v-model="sms_account"
                  :items="sms_account_options"
                  :loading="sms_accounts.loading"
                  @click="get_link_data('SMS Account', sms_accounts, '')"
                  @update:search-input="get_link_data('SMS Account', sms_accounts, ...arguments)">
                </v-autocomplete>
              </v-list-item>
              <v-list-item v-if="enable_multi_kds_setup">
                <v-text-field
                  dense
                  label="KDS ID"
                  clearable
                  required
                  v-model="kds_id">
                </v-text-field>
              </v-list-item>

              <!-- Service Type Mapping -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title class="mb-2">Service Type Icons</v-list-item-title>
                  <v-list-item-subtitle class="mb-3">Map food service types to display icons (mdi-icon-name) or text</v-list-item-subtitle>
                  <div v-for="(val, key) in service_type_mapping" :key="key" class="d-flex align-center mb-2">
                    <v-chip small label outlined class="mr-2" style="min-width: 80px;">{{ key }}</v-chip>
                    <v-icon v-if="val && val.startsWith('mdi-')" class="mr-2">{{ val }}</v-icon>
                    <v-text-field
                      dense
                      hide-details
                      :value="val"
                      @input="$set(service_type_mapping, key, $event)"
                      placeholder="mdi-icon-name or text"
                      class="mt-0 pt-0"
                    ></v-text-field>
                  </div>
                </v-list-item-content>
              </v-list-item>

              <!-- Hidden Orders Auto-Close Timeout -->
              <v-list-item>
                <v-text-field
                  dense
                  label="Hidden Orders Auto-Close (minutes)"
                  clearable
                  hint="Auto-close hidden orders screen after N minutes of inactivity. Leave empty to disable."
                  persistent-hint
                  type="number"
                  v-model="hidden_orders_timeout">
                </v-text-field>
              </v-list-item>

              <!-- Secondary Server -->
              <v-subheader class="pl-0 mt-2" style="height: auto; padding-bottom: 4px;">Secondary Server (Optional)</v-subheader>
              <v-list-item>
                <v-text-field
                  dense
                  label="Secondary Local Server Host"
                  clearable
                  hint="Secondary server host. EX: http://192.168.1.2:9200"
                  persistent-hint
                  v-model="secondary_local_server_host">
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Secondary Server Endpoint"
                  clearable
                  hint="Secondary server endpoint to get orders from"
                  persistent-hint
                  v-model="secondary_server_endpoint">
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Secondary Server Card Background Color"
                  clearable
                  hint="CSS color applied to the card body of secondary-server orders (e.g., rgba(255,165,0,0.15))"
                  persistent-hint
                  v-model="secondary_server_card_bg_color">
                  <template v-slot:prepend v-if="secondary_server_card_bg_color">
                    <div :style="{ width: '20px', height: '20px', borderRadius: '4px', backgroundColor: secondary_server_card_bg_color, border: '1px solid #ccc' }"></div>
                  </template>
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  dense
                  label="Secondary Server Card Background Image URL"
                  clearable
                  hint="Background image URL for secondary-server order cards (overrides color when set)"
                  persistent-hint
                  v-model="secondary_server_card_bg_image">
                </v-text-field>
              </v-list-item>
            </v-col>
          </v-row>
        </v-list>
        <v-divider></v-divider>
        <v-list two-line subheader>
          <v-subheader>Filters</v-subheader>
          <v-row>
            <v-col cols="5">
              <v-list-item>
                <v-text-field
                  clearable
                  dense
                  label="Max Hours"
                  hint="Hours to show orders from, default is 2"
                  persistent-hint
                  v-model="hours_since">
                </v-text-field>
              </v-list-item>
              <v-list-item>
                <v-text-field
                  clearable
                  dense
                  label="Heart Beat"
                  hint="Auto loading every seconds"
                  persistent-hint
                  v-model="heart_beat">
                </v-text-field>
              </v-list-item>
            </v-col>
            <v-col cols="5">
            </v-col>
          </v-row>
        </v-list>
        <v-divider></v-divider>
        <v-list two-line subheader>
          <v-subheader>Item Groups</v-subheader>
          <v-row>
            <v-col cols="5">
              <v-list-item>
                <draggable v-model="selected_groups">
                  <transition-group>
                    <div v-for="g in selected_groups" :key="g">
                      <v-banner color="primary" outlined>
                        {{g}}
                        <v-btn slot="actions" icon color="red darken-1" @click="remove_item_group(g)">
                          <v-icon>mdi-close-circle-outline</v-icon>
                        </v-btn>
                      </v-banner>
                    </div>
                  </transition-group>
                </draggable>
              </v-list-item>
              <v-list-item class="add-item-group">
                <v-autocomplete
                  dense
                  append-icon=""
                  label="Add Item Group"
                  hint="Show only orders from given item groups"
                  persistent-hint
                  v-model="group_to_add"
                  :items="item_groups.items"
                  :loading="item_groups.loading"
                  @click="get_link_data('Item Group', item_groups, '')"
                  @update:search-input="get_link_data('Item Group', item_groups, ...arguments)">
                </v-autocomplete>
                <v-btn icon color="primary" @click="add_item_group()">
                  <v-icon>mdi-plus-circle-outline</v-icon>
                </v-btn>
              </v-list-item>
            </v-col>
            <v-col cols="5">
              <v-list-item>
                <v-autocomplete
                  dense
                  append-icon=""
                  clearable
                  label="Exclude Item Groups"
                  hint="Exclude grouped items in grouped mode"
                  persistent-hint
                  v-model="excluded_groups"
                  :items="item_groups.items"
                  :loading="item_groups.loading"
                  @click="get_link_data('Item Group', item_groups, '')"
                  @update:search-input="get_link_data('Item Group', item_groups, ...arguments)"
                  multiple>
                </v-autocomplete>
              </v-list-item>
              <v-list-item v-if="show_the_side_bar_priority_items">
                <div class="settings-section">
                  <h3>Priority Items for Summary</h3>
                  <p class="settings-description">Items that will be highlighted in the sidebar. Drag to reorder.</p>
                  <div class="priority-items">
                    <div
                      v-for="(item, index) in selected_priority_items"
                      :key="`priority-${index}`"
                      class="priority-item"
                      :class="{ 'dragging': dragged_index === index, 'drag-over': drag_over_index === index }"
                      draggable="true"
                      @dragstart="handle_drag_start($event, index)"
                      @dragend="handle_drag_end"
                      @dragover="handle_drag_over($event, index)"
                      @dragleave="handle_drag_leave"
                      @drop="handle_drop($event, index)"
                    >
                      <div class="drag-handle">
                        <GripVerticalIcon class="drag-icon" />
                      </div>
                      <input
                        disabled
                        type="text"
                        v-model="selected_priority_items[index]"
                        class="priority-input"
                        placeholder="Item name"
                      />
                      <button
                        @click="remove_priority_item(index)"
                        class="btn btn-outline-gray btn-sm"
                        title="Remove item"
                      >
                        <XIcon class="btn-icon" />
                      </button>
                    </div>
                    <v-list-item>
                      <v-autocomplete
                        dense
                        append-icon=""
                        label="Add Item"
                        v-model="priority_item_to_add"
                        :items="items.items"
                        :loading="items.loading"
                        @click="get_link_data('Item', items, '')"
                        @update:search-input="get_link_data('Item', items, ...arguments)">
                      </v-autocomplete>
                      <v-btn icon color="primary" @click="add_priority_item()">
                        <v-icon>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </v-list-item>
                  </div>
                </div>
              </v-list-item>
              <v-card flat>
                <v-card-title class="text-h6">
                  🕹️ Bump Bar Configuration
                  <v-spacer></v-spacer>
                  <v-btn small text color="error" @click="resetDefaults">
                    Reset Defaults
                  </v-btn>
                </v-card-title>

                <v-card-text>
                  <!-- Input Mode Toggle -->
                  <v-select
                    dense
                    label="Bump Bar Input Mode"
                    v-model="bump_bar_mode"
                    :items="['Keyboard', 'Web Serial']"
                    hint="Select how the bump bar device connects to this KDS"
                    persistent-hint
                    class="mb-4"
                  ></v-select>

                  <!-- Orders-per-scroll-jump -->
                  <v-text-field
                    dense
                    label="Orders to jump per scroll"
                    type="number"
                    min="1"
                    v-model.number="scroll_jump_size"
                    hint="How many order slots NAV_LEFT / NAV_RIGHT shifts the bump-bar index window (default: 8)"
                    persistent-hint
                    class="mb-4"
                  ></v-text-field>

                  <!-- Scroll pixel amount -->
                  <v-text-field
                    dense
                    label="Scroll amount (px)"
                    type="number"
                    min="1"
                    v-model.number="scroll_amount"
                    hint="Pixels the screen scrolls per NAV_LEFT / NAV_RIGHT press (default: 350)"
                    persistent-hint
                    class="mb-4"
                  ></v-text-field>

                  <!-- Web Serial settings — only shown when Web Serial mode is active -->
                  <template v-if="bump_bar_mode === 'Web Serial'">
                    <v-row align="center" class="mb-3">
                      <v-col cols="5">
                        <v-text-field
                          dense
                          label="Baud Rate"
                          type="number"
                          v-model.number="serial_baud_rate"
                          hint="Serial port baud rate (default: 9600)"
                          persistent-hint
                        ></v-text-field>
                      </v-col>
                      <v-col cols="7">
                        <v-btn color="primary" small @click="requestSerialPort">
                          <v-icon left small>mdi-usb-port</v-icon>
                          Connect to Bump Bar
                        </v-btn>
                        <v-alert v-if="serial_connect_status" type="success" dense text class="mt-2 mb-0">
                          {{ serial_connect_status }}
                        </v-alert>
                        <v-alert v-if="serial_connect_error" type="error" dense text class="mt-2 mb-0">
                          {{ serial_connect_error }}
                        </v-alert>
                      </v-col>
                    </v-row>
                  </template>

                  <v-alert type="info" dense text icon="mdi-keyboard">
                    Click the <strong>pen icon</strong> next to an action, then press the corresponding button on your Bump Bar Device to map it.
                  </v-alert>

                  <v-simple-table dense>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th class="text-left">Function / Action</th>
                          <th class="text-left">Mapped Key</th>
                          <th class="text-center" width="100">Edit</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(code, action) in bumpbar_map" :key="action">
                          
                          <td style="font-weight: 500;">
                            {{ formatName(action) }}
                          </td>

                          <td>
                            <v-chip 
                              v-if="recording_action === action" 
                              color="primary" 
                              small 
                              label 
                              class="pulsing-chip"
                            >
                              Listening... Press Key
                            </v-chip>

                            <v-chip v-else small label outlined>
                              {{ code }}
                            </v-chip>
                          </td>

                          <td class="text-center">
                            <v-btn 
                              icon 
                              small 
                              :color="recording_action === action ? 'red' : 'grey'"
                              @click="startRecording(action)"
                            >
                              <v-icon>
                                {{ recording_action === action ? 'mdi-record-circle' : 'mdi-pencil' }}
                              </v-icon>
                            </v-btn>
                          </td>

                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-list>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import draggable from 'vuedraggable'
import XIcon from './icons/XIcon.vue'
import GripVerticalIcon from './icons/GripVerticalIcon.vue'

export default {
  components: {
    draggable,
    XIcon,
    GripVerticalIcon
  },
  data () {
    return {
      ui_scale: 1.0,
      pre_orders: true,
      paid_orders: false,
      dark_mode: false,
      server_endpoint: 'api/method/pos_multi_currency.pos_multi_currency.doctype.pos_order.pos_order.sync/docs/',
      local_server_host: '',
      hours_since: 200,
      heart_beat: 20,
      enable_preparing: true,
      syncing: true,
      is_grouped: false,
      send_sms: false,
      show_the_side_bar_priority_items: false,
      sms_message: '',
      sms_sender_name: '',
      sms_account: '',
      smsRules: [
        v => !!v || 'This field is required when SMS is enabled',
      ],
      sms_accounts: {
        items: [],
        loading: false
      },
      item_groups: {
        items: [],
        loading: false
      },
      group_to_add: null,
      selected_groups: [],
      excluded_groups: [],
      transformers: ['POS Order', 'Local Server', 'Local Storage', 'Odoo', 'SAP'],
      selected_transformer: 'POS Order',
      token: '',
      items: {
        items: [],
        loading: false
      },
      priority_item_to_add: null,
      selected_priority_items: [],
      dragged_index: null,
      drag_over_index: null,
      is_drag_disabled: false,
      enable_multi_kds_setup: false,
      kds_id: null,
      service_type_mapping: {
        'Dine In': 'mdi-silverware',
        'Takeaway': 'mdi-shopping-outline',
        'Delivery': 'mdi-bicycle'
      },
      hidden_orders_timeout: null,
      enable_sync_completion_status: false,
      recording_action: null, // Stores the ID of the action currently being mapped
      // Web Serial
      bump_bar_mode: 'Keyboard',
      serial_baud_rate: 9600,
      scroll_jump_size: 8,
      scroll_amount: 350,
      serial_connect_status: null,
      serial_connect_error: null,
      // Secondary Server
      secondary_local_server_host: '',
      secondary_server_endpoint: '',
      // Secondary Server Order Visual Indicator
      secondary_server_card_bg_color: '',
      secondary_server_card_bg_image: ''
    }
  },

  computed: {
    ...mapState(['settings_dialog', 'bumpbar_map']),
    // Keep the saved account in the list even when the link lookup returns nothing
    // (no logged-in user), otherwise v-autocomplete drops the value and save() persists a blank.
    sms_account_options() {
      const items = this.sms_accounts.items || []
      if (this.sms_account && !items.includes(this.sms_account)) return [this.sms_account, ...items]
      return items
    },
  },

  beforeDestroy() {
    // Cleanup listener if component is closed while recording
    this.stopListening();
  },

  methods: {
    ...mapMutations({
      show_dialog: 'SET_SETTINGS',
    }),
    save() {
      // A blank sms_account makes the server fall back to the empty "SMS Settings" single,
      // which returns HTTP 200 without sending anything - a silent failure. Never persist it.
      if (this.send_sms && !(this.sms_message && this.sms_sender_name && this.sms_account)) {
        window.toast && window.toast.show({
          message: 'SMS Message, Sender Name and SMS Account are all required when Send SMS is on',
          type: 'error'
        })
        return
      }
      this.show_dialog(false)
      // pick attrs to store
      const kds_settings = (({ ui_scale, pre_orders, paid_orders, dark_mode,
        enable_preparing, syncing, is_grouped, send_sms, show_the_side_bar_priority_items, sms_message, sms_sender_name, sms_account, server_endpoint, hours_since,
        selected_groups, excluded_groups, selected_transformer, token, heart_beat, enable_multi_kds_setup, kds_id, local_server_host,
        selected_priority_items, service_type_mapping, hidden_orders_timeout, enable_sync_completion_status,
        bump_bar_mode, serial_baud_rate, scroll_jump_size, scroll_amount, secondary_local_server_host, secondary_server_endpoint,
        secondary_server_card_bg_color, secondary_server_card_bg_image }) => ({ ui_scale, pre_orders, paid_orders, dark_mode, enable_preparing, syncing,
          is_grouped, send_sms, show_the_side_bar_priority_items, sms_message, sms_sender_name, sms_account, server_endpoint, hours_since, selected_groups, excluded_groups, selected_transformer,
          token, heart_beat, selected_priority_items, enable_multi_kds_setup, kds_id, local_server_host, service_type_mapping, hidden_orders_timeout, enable_sync_completion_status,
          bump_bar_mode, serial_baud_rate, scroll_jump_size, scroll_amount, secondary_local_server_host, secondary_server_endpoint,
          secondary_server_card_bg_color, secondary_server_card_bg_image }))(this.$data)
      try {
        localStorage && localStorage.setItem("kds_settings", JSON.stringify(kds_settings))
        this.$store.commit('UPDATE_SETTINGS', kds_settings)
      } catch (e) {
        console.log("LocalStorage is full , did not save")
        // TODO: show error
      }
    },
    add_item_group() {
      if (!this.item_groups.items.includes(this.group_to_add)) return
      if (this.selected_groups.includes(this.group_to_add)) return
      this.selected_groups.push(this.group_to_add)
      this.group_to_add = null
    },
    remove_item_group(group_to_delete) {
      this.selected_groups = this.selected_groups.filter(g => g !== group_to_delete)
    },
    add_priority_item() {
      if (this.selected_priority_items.includes(this.priority_item_to_add)) return
      this.selected_priority_items.push(this.priority_item_to_add)
      this.priority_item_to_add = null
    },
    remove_priority_item(index) {
      this.selected_priority_items.splice(index, 1)
    },
    // Drag and Drop Methods
    handle_drag_start(event, index) {
      if (this.is_drag_disabled) {
        event.preventDefault()
        return
      }

      this.dragged_index = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/html', '')

      // Add a slight delay to allow the drag image to be captured
      setTimeout(() => {
        if (event.target) {
          event.target.style.opacity = '0.5'
        }
      }, 0)
    },

    handle_drag_end(event) {
      this.dragged_index = null
      this.drag_over_index = null

      if (event.target) {
        event.target.style.opacity = '1'
      }
    },

    handle_drag_over(event, index) {
      event.preventDefault()
      event.dataTransfer.dropEffect = 'move'

      if (this.dragged_index !== null && this.dragged_index !== index) {
        this.drag_over_index = index
      }
    },

    handle_drag_leave() {
      this.drag_over_index = null
    },

    handle_drop(event, dropIndex) {
      event.preventDefault()

      if (this.dragged_index === null || this.dragged_index === dropIndex) {
        this.drag_over_index = null
        return
      }

      // Reorder the array
      const items = [...this.selected_priority_items]
      const draggedItem = items[this.dragged_index]

      // Remove the dragged item
      items.splice(this.dragged_index, 1)

      // Insert at the new position
      const newIndex = this.dragged_index < dropIndex ? dropIndex - 1 : dropIndex
      items.splice(newIndex, 0, draggedItem)

      // Update the local settings
      this.selected_priority_items = items

      // Reset drag state
      this.dragged_index = null
      this.drag_over_index = null
    },

    // Convert "ACTION_HOLD_TOGGLE" to "Hold Toggle"
    formatName(key) {
      return key
        .replace('BUMP_', 'Order #')
        .replace('NAV_', 'Navigation ')
        .replace('ACTION_', '')
        .replace(/_/g, ' ');
    },

    startRecording(action) {
      // If already recording this one, stop.
      if (this.recording_action === action) {
        this.stopListening();
        return;
      }

      // Start recording
      this.recording_action = action;
      
      // Add global listener
      window.addEventListener('keydown', this.handleKeyPress, { once: true, capture: true });
    },

    stopListening() {
      this.recording_action = null;
      window.removeEventListener('keydown', this.handleKeyPress);
    },

    handleKeyPress(e) {
      if (!this.recording_action) return;

      e.preventDefault();
      e.stopPropagation(); // Stop the key from triggering other KDS events

      const newKey = e.key; // e.g., "Digit1", "F5", "NumpadEnter"

      // Save to Store & LocalStorage
      this.$store.commit('SET_BUMP_KEY', {
        action: this.recording_action,
        key: newKey
      });

      // User Feedback
      this.$root.toast.show({
        message: `Saved: ${this.formatName(this.recording_action)} ➔ [${newKey}]`,
        type: 'success'
      });

      this.stopListening();
    },

    resetDefaults() {
      if(confirm("Reset all key mappings to default?")) {
        this.$store.commit('RESET_BUMP_MAP');
      }
    },

    async requestSerialPort() {
      this.serial_connect_status = null
      this.serial_connect_error = null
      try {
        const port = await navigator.serial.requestPort()
        const info = port.getInfo()
        const vid = info.usbVendorId != null ? `VID: 0x${info.usbVendorId.toString(16).toUpperCase().padStart(4, '0')}` : null
        const pid = info.usbProductId != null ? `PID: 0x${info.usbProductId.toString(16).toUpperCase().padStart(4, '0')}` : null
        const detail = [vid, pid].filter(Boolean).join(', ')
        this.serial_connect_status = detail ? `Port granted (${detail})` : 'Port granted — ready to connect on next KDS load'
      } catch (e) {
        this.serial_connect_error = e.name === 'NotFoundError' ? 'No port selected' : (e.message || 'Failed to access serial port')
      }
    }
  },

  mounted () {
    const kds_settings = JSON.parse(localStorage?.getItem("kds_settings"), {})
    Object.assign(this, kds_settings)
  }
}
</script>

<style scoped>
  .add-item-group {
    display: flex;
    justify-content: space-between;
    margin: 1em 0;
  }
  .priority-items {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .settings-section {
    width: 100%;
    margin-bottom: 1rem;
    margin-top: 2rem;
  }

  .settings-section:last-child {
    margin-bottom: 0;
  }

  .settings-section h3 {
    color: rgba(0, 0, 0, 0.6);
    font-size: 1.125rem;
    font-weight: 400;
    margin-bottom: 0.5rem;
  }

  .settings-description {
    color: #94a3b8;
    font-size: 0.875rem;
    margin-top: -0.8rem;
    margin-bottom: 0.5rem;
  }

  .priority-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: white;
    border: 1px solid #374151;
    border-radius: 0.5rem;
    padding: 0.5rem;
    transition: all 0.2s;
    cursor: move;
  }

  .priority-item:hover {
    background: rgba(15, 23, 42, 0.8);
    border-color: #4b5563;
  }

  .priority-item.dragging {
    opacity: 0.5;
    transform: rotate(2deg);
  }

  .priority-item.drag-over {
    border-color: #3b82f6;
    background: rgba(59, 130, 246, 0.1);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.2);
  }

  .drag-handle {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #6b7280;
    cursor: grab;
    padding: 0.25rem;
    border-radius: 0.25rem;
    transition: all 0.2s;
  }

  .drag-handle:hover {
    color: #9ca3af;
    background: rgba(255, 255, 255, 0.05);
  }

  .drag-handle:active {
    cursor: grabbing;
  }

  .drag-icon {
    width: 1rem;
    height: 1rem;
  }

  .priority-input {
    flex: 1;
    margin-left: 0;
    width: auto;
    cursor: text;
    color: #9ca3af;
  }

  /* Drag and drop visual states */
  .priority-item[draggable="true"] {
    user-select: none;
  }

  .priority-item[draggable="true"]:hover .drag-handle {
    color: #d1d5db;
  }

  /* Smooth transitions for reordering */
  .priority-item {
    transition: transform 0.2s ease, background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease;
  }

  .btn-icon {
    width: 1rem;
    height: 1rem;
    margin-right: 0.5rem;
  }

  /* Animation for the "Listening" state */
  .pulsing-chip {
    animation: pulse-opacity 1s infinite;
  }

  @keyframes pulse-opacity {
    0% { opacity: 1; }
    50% { opacity: 0.5; }
    100% { opacity: 1; }
  }
</style>
